import React from 'react';
import { Pin, Calendar, CalendarPlus, UserPlus, Trash2 } from 'lucide-react';

/**
 * ConversationDropdown - Dropdown menu for conversation actions
 */
const ConversationDropdown = ({
  isOpen,
  isPinned,
  onPin,
  onAddToMeeting,
  onNewMeeting,
  onAddContact,
  onDelete,
  onClose,
  className = ''
}) => {
  if (!isOpen) return null;

  const handleAction = (action) => (e) => {
    e.stopPropagation();
    action?.();
    onClose?.();
  };

  return (
    <div 
      className={`absolute right-4 top-12 w-48 bg-gray-900 border border-gray-400/20 rounded-lg shadow-xl z-20 ${className}`}
      onClick={(e) => e.stopPropagation()}
    >
      {onPin && (
        <button
          onClick={handleAction(onPin)}
          className="w-full text-left px-4 py-2.5 hover:bg-gray-800 text-sm text-white flex items-center gap-2 border-b border-gray-400/10"
        >
          <Pin size={16} className="text-purple-400" />
          {isPinned ? 'Unpin Conversation' : 'Pin Conversation'}
        </button>
      )}
      
      {onAddToMeeting && (
        <button
          onClick={handleAction(onAddToMeeting)}
          className="w-full text-left px-4 py-2.5 hover:bg-gray-800 text-sm text-white flex items-center gap-2 border-b border-gray-400/10"
        >
          <Calendar size={16} className="text-purple-400" />
          Add to Meeting
        </button>
      )}
      
      {onNewMeeting && (
        <button
          onClick={handleAction(onNewMeeting)}
          className="w-full text-left px-4 py-2.5 hover:bg-gray-800 text-sm text-white flex items-center gap-2 border-b border-gray-400/10"
        >
          <CalendarPlus size={16} className="text-purple-400" />
          New Meeting
        </button>
      )}
      
      {onAddContact && (
        <button
          onClick={handleAction(onAddContact)}
          className="w-full text-left px-4 py-2.5 hover:bg-gray-800 text-sm text-white flex items-center gap-2 border-b border-gray-400/10"
        >
          <UserPlus size={16} className="text-purple-400" />
          Add/Edit Contact
        </button>
      )}
      
      {onDelete && (
        <button
          onClick={handleAction(onDelete)}
          className="w-full text-left px-4 py-2.5 hover:bg-red-900 text-sm text-red-400 flex items-center gap-2"
        >
          <Trash2 size={16} className="text-red-400" />
          Delete Conversation
        </button>
      )}
    </div>
  );
};

export default ConversationDropdown;
